import * as getterTypes from '../types/getters';
import * as mutationTypes from '../types/mutations';

const getters = {
  [getterTypes.GET_DRAWER]: state => state.drawer,
};

const actions = {};

const mutations = {
  [mutationTypes.SET_DRAWER](state, drawer) {
    state.drawer = drawer;
  },
};

export default {
  state: {
    drawer: false,
  },
  getters,
  actions,
  mutations,
};
